import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class Minus3Day extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = -3;

  public getName(): string {
    return Translator.trans("payment-offset-minus-3-day");
  }

}

export { Minus3Day }
